<template >
    <div>
        <div class="main-list-wrap pad20">
            <template v-if="[49].indexOf(getUserRoleId)>-1 && (checkProperty(caseDetails, 'verifierInfo', 'email') == checkProperty(getUserData, 'email')) && [4,5,6,8,9,10].indexOf(checkProperty(caseDetails, 'statusDetails','id'))>-1">
                <div v-if="checkProperty(caseDetails, 'verifierApprOrReject') == false || checkProperty(caseDetails, 'verifierApprOrReject') == true"> 
                  <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                    It seems already action has been taken against I-9 Form.                  
                  </vs-alert>    <br/>
              </div>
            </template>
            <verifierDocument v-if="checkProperty(caseDetails, 'verifierDetails', 'identifyDoc') && checkProperty(caseDetails['verifierDetails'], 'identifyDoc', 'length')>0 " :caseDetails="caseDetails"/>
            <div>
                <h3 class="title-header">Personal Information</h3>
                <div class="vx-row m-0 main-list-panel">
                    <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'verifierDetails','firstName')">
                        <div class="main-list">
                            <p>First Name<span>{{caseDetails.verifierDetails.firstName}}</span></p>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'verifierDetails','lastName')">
                        <div class="main-list">
                            <p>Last Name<span>{{caseDetails.verifierDetails.lastName}}</span></p>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'verifierDetails','title')">
                        <div class="main-list">
                            <p>Title/Designation<span>{{caseDetails.verifierDetails.title}}</span></p>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'verifierDetails', 'busiOrOrgName') ">
                        <div class="main-list">
                            <p>Business/Organization Name
                                <span>
                                    {{ caseDetails.verifierDetails.busiOrOrgName}}
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="vx-col w-full p-0"
                    v-if=" checkProperty(caseDetails ,'verifierDetails' ,'address' )  &&
                        (
                            checkProperty(caseDetails['verifierDetails'] ,'address' ,'line1' )
                        || checkProperty(caseDetails['verifierDetails']['address'] ,'locationDetails' ,'name' )
                        || checkProperty(caseDetails['verifierDetails']['address'] ,'stateDetails' ,'name' )
                        || checkProperty(caseDetails['verifierDetails']['address'] ,'countryDetails' ,'name' )
                        )">
                    <div class="main-list">
                        <p>Address<span v-html="$options.filters.addressformat(caseDetails.verifierDetails.address)"></span></p>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
 </template>
 
<script>
import verifierDocument from "@/views/i-9Module/verifierFlow/verifierDocument.vue";
import NoDataFound from "@/views/common/noData.vue";
import assignVerifierModal from "@/views/i-9Module/assignVerifierModal.vue";
export default {
    components: {
        NoDataFound,
        assignVerifierModal,
        verifierDocument
    },
    mounted(){
        this.showVerifier = true
    },
    methods:{
        reloadPetition(data){
            this.$emit('reloadPetition')
        },
    },
    data: () => ({

    }),
    props: {
        caseDetails: {
            type: Object,
            default: null
        },
        i9Id: {
            default: null
        },
    
    },
}
</script>